module.exports = __webpack_public_path__ + "static/media/company.b7b38c11.svg";